import { createContext } from 'react'
import { px2rem } from '@/utils/styleUtils'

const customNavContext = createContext({
  hideNavigation: 0,
  statusBarStyle: 0,
  navigationBackground: '#ffffff',
  statusBarHeight: px2rem(84),
  statusBarHeightPx: 84,
  componentPaddingTop: px2rem(88),
})

export default customNavContext
